var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 78,
    viewBox: "0 0 167 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7006 59.9387C33.5332 55.5722 34.8798 49.111 29.9484 39.4472C25.3792 30.5095 27.153 22.6517 33.7282 16.3023C53.8253 -3.06274 113.179 -3.73307 140.612 6.7501C151.887 11.07 158.787 16.4233 163.022 27.2137C166.988 37.3245 164.787 50.9544 157.961 59.166C150.503 68.1316 138.077 72.0697 127.072 74.09C112.083 76.8365 101.793 77.1717 87.6486 76.2314C74.4425 75.3469 71.6657 73.308 58.3852 72.8611C55.4041 72.7587 52.423 72.7494 49.4511 72.8704C40.2477 73.2335 27.831 77.0972 15.925 77.8513C10.585 78.1865 7.00018 77.9351 7.00018 77.0879C7.00018 76.2407 10.6221 74.4624 14.5041 72.0977C19.7141 68.9136 26.8837 65.832 30.7099 59.9294L30.7006 59.9387Z",
    fill: "#4598B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.64bbc4e6073df07b667613007e496a13.svg";
export { ForwardRef as ReactComponent };